export interface InvestmentObjectives {
  // NOTE: Copies how VGIM cbbFeature.investment.objectives prop looks like at runtime
  CAP: boolean | null;
  Income: boolean | null;
  Growth: boolean | null;
  Speculation: boolean | null;
}

export const defaultInvestmentObjectivesValues: InvestmentObjectives = {
  CAP: null,
  Income: null,
  Growth: null,
  Speculation: null,
};
